import { APIcaller } from './APIcaller';

const sendProductionPlanning = (storeId, planningDate, startTime, endTime) =>
  APIcaller.apiPost(`/production/zelty`, { storeId, planningDate, startTime, endTime });

export const planning = {
  sendProductionPlanning,
};
